<script setup lang="ts">
defineProps<{ disabled?: boolean; label?: string }>();
defineEmits<{ (e: "click"): void }>();
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
    class="mx-auto block px-14 py-4 rounded-2xl bg-gradient-to-b from-amber-300 to-pot1 text-amber-950 text-lg font-extrabold uppercase tracking-widest shadow-[0_8px_0_rgb(180,83,9),0_10px_20px_rgba(180,83,9,0.25)] active:translate-y-1 active:shadow-[0_4px_0_rgb(180,83,9),0_5px_10px_rgba(180,83,9,0.2)] transition-all disabled:from-slate-200 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-[0_4px_0_rgb(203,213,225)] disabled:cursor-not-allowed"
  >
    {{ label ?? "Spin" }}
  </button>
</template>
